import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingOmit } from './types/mailing-omit.type';

/**
 * Retrieves a list of mailing omits for a given mailing ID.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which omits are to be fetched.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link MailingOmit} objects.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getMailingOmits = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingOmit>>(formatString(Uri.mailing.getOmits, mailingId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
